import { createAction, createReducer } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { apiCallBegan } from 'store/apiCalls'
import { gameIdSelector } from 'store/user/selectors'

// ACTIONS
const marketForecastRequested = createAction('marketForecast/requested')
const marketForecastRequestFailed = createAction('marketForecast/requestFailed')
const marketForecastReceived = createAction('marketForecast/received')

// REDUCER
export const initialState = {
  data: null,
  loading: false,
  success: false
}

const marketForecastReducer = createReducer(initialState, {
  [marketForecastRequested.type]: (state) => {
    state.loading = true
  },
  [marketForecastReceived.type]: (state, action) => {
    state.loading = false
    state.success = true
    state.data = action.payload.data
  },
  [marketForecastRequestFailed.type]: (state, action) => {
    state.loading = false
    state.success = false
    toast.error(action.payload.message)
  }
})

export default marketForecastReducer

// PUBLIC ACTIONS
export const loadMarketForecast = () => (dispatch, getState) => {
  const id = gameIdSelector(getState())

  dispatch(
    apiCallBegan({
      url: `/games/${id}/dashboard/market_forecasts`,
      onStart: marketForecastRequested.type,
      onSuccess: marketForecastReceived.type,
      onError: marketForecastRequestFailed.type
    })
  )
}
